import React from 'react';
import { FaBoxOpen } from 'react-icons/fa';

const EmptyState = ({ message = "No products found in this category" }) => {
  return (
    <div className="col-span-full flex flex-col items-center justify-center py-16 px-4">
      <FaBoxOpen className="w-16 h-16 text-gray-300 mb-4" />
      <h3 className="text-xl font-semibold text-gray-700 mb-2">No Products Found</h3>
      <p className="text-gray-500 text-center max-w-md">{message}</p>
      <button 
        className="mt-6 px-6 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 transition-colors"
        onClick={() => window.location.reload()}
      >
        Refresh Page
      </button>
    </div>
  );
};

export default EmptyState;
